<div class="pop" [ngClass]="{'modeone': isModeOne, 'modetwo': isModeTwo}">
  <header>
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 1978.2 1688.6"
      xml:space="preserve" class="box-icon">
      <path
        d="M1186.2 113.5l754.5 1217.6c45.1 72.8 47.1 159.3 5.5 234.1-41.6 74.8-116.3 118.8-202 118.8h-1509c-85.6 0-160.4-44-202-118.8-41.6-74.8-39.6-161.3 5.5-234.1L793.3 113.5C836.4 43.9 907.8 3.9 989.7 3.9s153.4 40 196.5 109.6zm696.2 1253.6L1127.9 149.5c-30.7-49.6-79.9-76.8-138.1-76.8s-107.4 27.2-138.1 76.8L97 1367.1c-32.1 51.8-33.5 111.5-3.9 164.8 29.7 53.4 81 83.3 142 83.3h1509.1c61 0 112.3-30 142-83.3 29.7-53.2 28.3-113-3.8-164.8z" />
      <path
        d="M939.5 1151.3l-51.3-539.9c-5.3-55.6 45.7-101.5 101.5-101.5s106.8 45.9 101.5 101.5l-51.3 539.9c-.6 6-5.6 10.6-11.7 10.6h-77c-6.1 0-11.1-4.6-11.7-10.6zM989.7 1261.8c48.5 0 87.9 39.4 87.9 87.9 0 48.5-39.4 87.9-87.9 87.9-48.5 0-87.9-39.4-87.9-87.9 0-48.5 39.4-87.9 87.9-87.9z" />
    </svg>
  </header>
  <p *ngFor="let text of texts" [langkey]="text"></p>

  <footer class="buttons" [class.in_column]="!buttons_in_row">
    <a *ngFor="let btn of buttons" class="btn {{btn.style}}" (click)="btn.onClick(dialogRef)"
      [langkey]="btn.langkey"></a>
  </footer>
</div>